import { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import config from '../config';

/**
 * TokenRefresh Component
 * Automatically refreshes access token every 14 minutes (before 15-minute expiration)
 * Only runs when user is authenticated
 */
const TokenRefresh = () => {
  const { authData, login } = useContext(AuthContext);

  useEffect(() => {
    // Only run if user is authenticated
    if (!authData.token) return;

    // Refresh token every 14 minutes (1 minute before expiration)
    const REFRESH_INTERVAL = 14 * 60 * 1000; // 14 minutes in milliseconds

    const refreshToken = async () => {
      try {
        const response = await fetch(`${config.API_URL}api/refresh-token`, {
          method: 'POST',
          credentials: 'include'
        });

        if (response.ok) {
          const session = await response.json();
          if (session.user) {
            const user = session.user;
            login(user.id, user.usertype_id, user.terminal_id, user);
          }
        } else {
          console.warn('Token refresh failed:', response.status);
          // Don't logout yet, let the http hook handle it on next API call
        }
      } catch (error) {
        console.error('Token refresh error:', error);
        // Don't logout yet, let the http hook handle it on next API call
      }
    };

    // Initial refresh after 14 minutes
    const intervalId = setInterval(refreshToken, REFRESH_INTERVAL);

    // Cleanup on unmount or logout
    return () => clearInterval(intervalId);
  }, [authData.token, login]);

  // This component doesn't render anything
  return null;
};

export default TokenRefresh;
